import React, { useState } from "react";
import TeamService from "services/TeamService";
import { useTimelineContext } from "store/contexts/timelineContext";
import Button from "components/CustomButton";
import { Modal } from "react-responsive-modal";
import { useToasts } from "react-toast-notifications";
import { ReactComponent as DeleteIcon } from "assets/img/icons/Delete.svg";
import { useTeamActionContext } from "store/contexts/teamActionContext";

var styles = {
  titleDailog: {
    padding: "24px 24px 10px",
    fontSize: "1.25rem",
    fontWeight: "900",
    marginBottom: "0",
  },
  headingDailog: {
    fontSize: "1rem",
    padding: "0px 24px",
    marginBottom: "12px",
  },
  actionButton: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    textAlign: "center",
    padding: "10px 8px",
  },
};

export default ({ listTask }) => {
  const classes = styles;
  const { teamId, deleteNewPost } = useTeamActionContext();
  const { addToast } = useToasts();
  const { deleteTask, setHide } = useTimelineContext();
  const [confimDeleteTask, setConfirmDeleteTask] = useState(false);

  const handleModal = async (val) => {
    setConfirmDeleteTask(val);
    setHide(val);
  };

  const deleteMyTask = async () => {
    try {
      await TeamService.deleteTodolistTask(
        teamId,
        listTask.todo_list_id,
        listTask.id
      );

      deleteTask(listTask);

      var post = { id: listTask.team_post_id };
      deleteNewPost(post);

      addToast("Task Deleted ", { appearance: "error" });
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <span
        onClick={() => handleModal(true)}
        style={{ cursor: "pointer" }}
        className="p-share-btn"
      >
        <DeleteIcon className="mwh-15" style={{ fill: "#6c737e" }} /> Delete
      </span>
      <Modal
        open={confimDeleteTask}
        onClose={() => handleModal(false)}
        showCloseIcon={false}
        classNames={{ modalContainer: "modalContainer", modal: "modalPadding" }}
      >
        <div className="modal-body">
          <h2 style={classes.titleDailog}>Delete Task Confirmation</h2>
          <h6 style={classes.headingDailog}>
            Do you want to delete this task, kindly confirm.
          </h6>
          <div style={classes.actionButton}>
            <Button
              buttonClass="small-btn me-2"
              onClick={() => {
                handleModal(false);
              }}
            >
              Cancel
            </Button>
            <Button onClick={deleteMyTask} buttonClass=" small-reject-btn ">
              Confirm
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};
